<template>
    <div id="fs5-view-rank-details">
        <div class="get-paid-bblue get-paid-box-ranking">
            <div class="get-paid-divItemRank">
                <img :src="view.gravatar" :alt="view.user.nome" class="get-paid-gravatarUser">
            </div>
            <div class="get-paid-boxPositionRank get-paid-divItemRank">
                <p class="get-paid-positionRank" v-html="user.position != 0 ? (user.position + 'º') : '-'"></p>
                <div>
                    <p class="get-paid-labelPosition">{{ view.translations['label_position_on_ranking'] }}</p>
                </div>
            </div>
            <div class="get-paid-divRanking get-paid-divItemRank"></div>
            <div class="get-paid-divItemRank">
                <p class="get-paid-nameUser" v-html="view.user.nome.length > 14 ? view.user.nome.slice(0,14) + '...' : view.user.nome"></p>
                <div>
                    <p class="get-paid-pointsUser" v-html="user.points + ' ' + view.translations['fs5_get_paid_points']"></p>
                </div>
            </div>
            <div>
                <fs5-button 
                    :label="view.translations['view_rank_details']"
                    :btn-type="'primary'"
                    :text-transform-type="'uppercase'"
                    :icon="'/internacional/public/office5/img/franchise_dashboard/svg/trophy.svg'"
                    @clicked="viewRankDetails()"
                ></fs5-button>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: 'fs5-view-rank-details',
        props: ['view'],
        data() {
            return {
                user: {
                    position: 0,
                    points: 0,
                }
            }
        },
        methods: {
            viewRankDetails()
            {
                window.location.assign('/' + this.view.lang + '/office/franchise-system/rank');
            }
        },
        mounted() {
            axios
                .get(window.__env.microservices.bucket.host + '/users/' + this.view.user.id + '/ranking',{
                    mode: "cors",
                    headers: {
                        Origin: "*"
                    }
                })
                .then((response) => {
                    this.user.position = response.data.position;
                    this.user.points = response.data.points;
                })
                .catch(e => {});
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../../../../scss/extras/_variables'; // see fonts and colors with prefix $fs5
    #fs5-view-rank-details{
        font: inherit;
        text-transform: uppercase;
    }
    .get-paid-bblue{
        border: 1px solid $fs5-color1;
        background-color: #fff;
        width: 100%;
        border-radius: 8px;
        padding: 0.62em;
    }
    .get-paid-divItemRank {
        margin: 0.62em;
    }
    .get-paid-box-ranking{
        display: flex;
        flex-direction: row;
        column-gap: 5%;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
    }
    .get-paid-boxPositionRank{
        transform: translate(0.62em, 0.62em);
    }
    .get-paid-gravatarUser{
        width: 6.8em;
        height: 6.8em;
        border-radius: 50%;
    }
    .get-paid-nameUser {
        font-size: 1.3em;
        color: $fs5-color5;
        align-items: center;
        letter-spacing: 0.12em;
        font-weight: bold;
    }
    .get-paid-divRanking {
        border-right: 2px solid $fs5-color11;
        height: 80px;
    }
    .get-paid-pointsUser {
        font-size: 1em;
        line-height: 1.8em;
        letter-spacing: 0.12em;
        font-weight: bold;
        color: $fs5-color11;
    }
    .get-paid-positionRank{
        color: $fs5-color5;
        font-size: 3.8em;
        text-align: center;
        font-weight: bold;
        line-height: 50%;
    }
    .get-paid-labelPosition{
        color: $fs5-color11;
        font-size: 0.87em;
    }
    @media only screen and (max-width: 1020px) {
        .get-paid-divRanking {
            display: none;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/get_paid/user/view_rank_details/index.vue